var spanishTranslations = {
    translation: {
        alertsCategoriesTitles: {
            balanceAlerts: ' Alertas de Saldo',
            paymentAlerts: 'Alertas de Pagos',
            profileAlerts: 'Alertas del Perfil',
            spendingAlerts: 'Alertas de Gastos',
            securityAlerts: 'Alertas de Seguridad',
            uncategorized: 'Alertas Sin Categorizar',
            payLaterAlerts: 'Alertas de Préstamo Pay Later'
        },
        alertsCategoriesSubtitle: {
            securityAlerts: 'Por su seguridad, siempre recibirá un correo electrónico para las siguientes alertas y estas no se podrán desactivar.'
        },
        alertsTitle: {
            auto_pay: 'Pagos',
            authorized_user: 'Usuario Autorizado',
            available_credit: 'El crédito disponible se encuentra dentro del límite de crédito de $%s ',
            generous_tip: 'Propina generosa supera %s %',
            balance_exceeds: 'El saldo supera $%s',
            balance_overlimit: 'El saldo supera el límite de crédito',
            freeze_account: 'Congelar Cuenta',
            international_transaction: 'Se produce una transacción internacional',
            payment_past_due: 'Pago olvidado',
            payment_reminder: 'El pago o el pago automático vence en %d días',
            payment_scheduled: 'El pago está programado',
            profile_change: 'Cambio en el Perfil',
            profile_change_address: 'Cambios en la Dirección del Perfil',
            profile_change_email: 'Cambios en el Correo Electrónico del Perfil',
            profile_change_name: 'Cambios en el Nombre del Perfil',
            profile_change_phone: 'Cambios en el Teléfono del Perfil',
            promo_purchase_expiry: 'La compra promocional vencerá en %d días',
            statement_available: 'El estado de cuenta está disponible',
            transaction_over_user_creditlimit: 'La transacción supera los $%s',
            transaction_refund: 'Se registró un crédito o reembolso',
            transaction_card_not_present: 'Se produce una transacción en línea, por teléfono o por correo',
            transaction_decline: 'Transacciones rechazadas',
            statement_ready: 'Estado de Cuenta Electrónico',
            select_the_account: 'Seleccione la cuenta en la que quiere administrar las alertas.',
            approved_transactions: 'Transacciones aprobadas',
            purchase_exceeds: 'Transacciones aprobadas por encima de $%s',
            transaction_authorization: 'Todas las transacciones aprobadas',
            special_financing: 'Una compra de financiación especial caducará en %d días ',
            syf_pay_later: 'Alertas y recordatorios de préstamos'
        },
        marketingPrivacySettingsTitle: {
            marketingSettings: 'Configuración de Comunicaciones Comerciales',
            privacySettings: 'Configuración de Privacidad',
            selectAccount: 'Seleccione la cuenta para la cual usted desea administrar sus preferencias de comunicaciones comerciales y privacidad.'
        },
        marketingPrivacySettings: {
            successMessage: 'Sus cambios se han guardado.',
            errorMessage: 'No pudimos guardar sus cambios. Intente nuevamente.'
        },
        alertsSubTitle: {
            auto_pay: 'Pago automático, pago programado, pago registrado',
            freeze_account: 'Confirmación de que la cuenta se ha congelado temporalmente',
            profile_change: 'Se ha cambiado su información personal (dirección, correo electrónico o teléfono)',
            statement_ready: 'Su estado de cuenta está disponible en línea'
        },
        marketingPrivacySettingsBodyTitle: {
            marketingSettings: 'Elija cómo desea que le enviemos comunicaciones sobre otros productos de Synchrony.',
            privacySettingsEnrolled: 'Estoy de acuerdo con compartir mi información.',
            privacySettingsUnenrolled: 'No compartan mi información.'
        },
        marketingPrivacySettingsError: {
            title: 'Lo sentimos',
            infoNotAvailable: 'Lamentablemente, no podemos recuperar sus configuraciones de comunicaciones comerciales y privacidad ahora mismo. Por favor intente nuevamente más tarde.'
        },
        alertsBody: {
            leftDescription: 'Enviar alerta cuando: ',
            leftDescriptionSyfPayLaterOrApprovedTransactions: 'Enviar alerta para: ',
            rightDescription: 'Enviar alerta a: ',
            addMobileNumber: 'Agregar número de móvil'
        },
        inputLabels: {
            available_credit: 'Su crédito disponible está dentro de este monto del límite de crédito.',
            generous_tip: 'Una propina supera este porcentaje en una transacción:',
            balance_exceeds: 'El saldo en esta cuenta supera: ',
            balance_overlimit: 'El saldo de la cuenta supera el límite de crédito de la cuenta.',
            international_transaction: 'Se produce una transacción en esta cuenta.',
            payment_past_due: 'No se ha recibido el pago mínimo adeudado en su cuenta.',
            payment_reminder: 'Un pago o un pago automático se vence en: ',
            payment_scheduled: 'Está programado que se realice un pago en esta cuenta.',
            promo_purchase_expiry: 'Una compra promocional vencerá en: ',
            statement_available: 'El estado de cuenta está disponible',
            transaction_over_user_creditlimit: 'Se produce una transacción que supera:',
            transaction_refund: 'En esta cuenta se registró un crédito o reembolso del comerciante.',
            transaction_card_not_present: 'Se produce una transacción en línea, por teléfono o por correo.',
            transaction_decline: 'Se rechazó una transacción.',
            special_financing: 'Una compra de financiación especial caducará en: ',
            syf_pay_later: 'Cualquier pago y actividad de cuenta relacionadas con su cuenta de alertas de Synchrony Pay Later.'
        },
        inputPlaceHolders: {
            available_credit: 'Monto',
            generous_tip: 'Porcentaje de Propina',
            select_account: 'Seleccione la Cuenta',
            balance_exceeds: 'Monto',
            payment_reminder: 'Seleccione los Días',
            promo_purchase_expiry: 'Seleccione los Días',
            transaction_over_user_creditlimit: 'Monto',
            purchase_exceeds: 'Monto',
            approved_transactions: 'Monto'
        },
        inputHelperText: {
            available_credit: 'Solo monto en dólares enteros',
            generous_tip: 'Números enteros entre 1 y 200 solamente',
            balance_exceeds: 'Solo monto en dólares enteros',
            transaction_over_user_creditlimit: 'Solo monto en dólares enteros',
            purchase_exceeds: 'Solo monto en dólares enteros',
            approved_transactions: 'Solo monto en dólares enteros'
        },
        deliveryIconsTitle: {
            email: 'Correo Electrónico',
            text: 'Texto',
            push: 'Aplicación',
            clientNotification: 'Cliente',
            mail: 'Correo Directo'
        },
        buttonLabels: {
            turnOn: 'ACTIVAR',
            turnOff: 'DESACTIVAR',
            save: 'GUARDAR',
            cancel: 'CANCELAR',
            edit: 'EDITAR',
            close: 'CERRAR',
            updatePhoneOrEmail: 'Actualizar teléfono o correo electrónico',
            updateConsent: 'ACTUALIZAR CONSENTIMIENTO',
            updateContactInformation: 'Actualizar la información de contacto'
        },
        accountSummaryPage: {
            navigationButtonLabel: 'RECIBIR ALERTAS'
        },
        errorPage: {
            navigationButtonLabel: 'Atrás',
            title: 'Ups...',
            fourHundred: 'Lamentablemente no podemos procesar su solicitud en este momento. Por favor, intente nuevamente más tarde.',
            fiveHundred: 'Lamentablemente estamos experimentando problemas técnicos. Por favor, intente nuevamente más tarde.',
            default: 'Lamentablemente no podemos procesar su solicitud en este momento. Por favor, intente nuevamente más tarde.',
            code: 'Código:',
            unregisteredHint: 'Si su cuenta no está registrada, vuelva al Administrador de Cuentas para registrar su cuenta.',
            accountsDataNotAvailable: 'Lamentablemente, no podemos recuperar su información de alertas en este momento. Por favor, intente nuevamente más tarde.'
        },
        errorTitles: {
            page: 'Error de Red'
        },
        errorMessages: {
            approvedTrnxType: 'Por favor haga una selección',
            amountTextField: 'Por favor ingrese un monto válido. Solo montos en dólares enteros',
            percentageTextField: 'Por favor ingrese cantidad válida. Números enteros entre 1 y 200 solamente',
            deliveryMethod: 'Seleccione al menos un método de entrega.',
            updatePreference: 'Lo sentimos, no podemos guardar sus cambios en este momento. Por favor intente nuevamente más tarde.',
            mailOrPhoneBeforeLink: 'La inscripción a las alertas no fue exitosa debido a que falta la información de contacto. Por favor, ',
            mailOrPhonePreferenceLink: 'actualice su perfil aquí',
            mailOrPhoneAfterLink: 'e intente de nuevo.',
            code: 'Código',
            syfPayLaterDeliveryMethod: 'Seleccione Texto para inscribirse en alertas de mensaje de texto.',
            syfPayLaterSubText: 'Siempre se envía un correo electrónico.'
        },
        headerLabels: {
            backToAccountSummary: 'volver a resumen de cuenta',
            getAlerts: 'Obtener alertas',
            alertsManagement: 'Administrar Alertas',
            marketingPrivacySettings: 'Configuración de Comunicaciones Comerciales y Privacidad'
        },
        footerLabels: {
            copyRightBy: 'Synchrony',
            internetPrivacyPolicy: 'Política de Privacidad de Internet',
            privacyPolicy: 'Política de Privacidad',
            websiteUsageAgreement: 'Acuerdo de Uso del Sitio Web'
        },
        toolTip: {
            email: 'Siempre le enviaremos un correo electrónico para esta alerta y no se puede desactivar',
            autopay: 'Si está inscrito en  un pago automático, recibirá un recordatorio de un pago automático.',
            emailText: 'Siempre le enviaremos un correo electrónico y un mensaje de texto para esta alerta y no se puede desactivar',
            emailPush: 'Siempre le enviaremos un correo electrónico y una notificación en la aplicación para esta alerta y no se puede desactivar',
            emailTextPush: 'Siempre le enviaremos un correo electrónico, un mensaje de texto y una notificación en la aplicación para esta alerta y no se puede desactivar',
            text: 'Siempre le enviaremos un mensaje de texto para esta alerta y no se puede desactivar',
            textPush: 'Siempre le enviaremos un mensaje de texto y una notificación en la aplicación para esta alerta y no se puede desactivar',
            push: 'Siempre le enviaremos una notificación en la aplicación para esta alerta y no se puede desactivar'
        },
        termsAndConditions: {
            title: 'Términos y Condiciones de las Alertas de Mensajes de Texto y Correos Electrónicos de la Cuenta',
            phoneLabel: 'Número de Teléfono',
            emailLabel: 'Dirección de Correo Electrónico',
            acknowledgeLabel: 'Estoy de acuerdo con los Términos y Condiciones anteriores.',
            linkLabel: 'Términos y Condiciones de las Alertas de Mensajes de Texto y Correos Electrónicos de la Cuenta.',
            contentBeforeLink: "Al marcar la casilla a continuaci\u00F3n y al hacer clic en \"GUARDAR\", usted ACEPTA ",
            contentAfterLink: " Si elige recibir alertas por mensaje de texto, pero antes de realizar dicha elecci\u00F3n, ha revocado su consentimiento para que utilicemos tecnolog\u00EDa automatizada para llamar o enviar mensajes de texto a los n\u00FAmeros de celular que nos ha facilitado, tambi\u00E9n acepta que, al elegir recibir alertas por mensaje de texto, aprueba que utilicemos dicha tecnolog\u00EDa automatizada para llamar o enviar mensajes de texto a dichos n\u00FAmeros\n            seg\u00FAn los t\u00E9rminos del consentimiento de comunicaciones establecido en el acuerdo que rige su cuenta \"Consentimiento del Acuerdo de Cr\u00E9dito\", incluso con el prop\u00F3sito de enviarle mensajes de texto de las alertas de cuenta que seleccione y para otros fines relacionados con la cuenta. Usted acepta que, si pretende cancelar las alertas de la cuenta por medio de mensajes de texto, dicha cancelaci\u00F3n se aplicar\u00E1 \u00FAnicamente a los mensajes de texto de alerta de la cuenta y no cancelar\u00E1 otros mensajes para los que tenemos  su consentimiento. Pueden aplicarse tarifas de datos o de mensajes de texto. En cuanto a las alertas de cuenta enviadas por mensaje de texto, env\u00EDe la palabra STOP para cancelar dichas alertas y env\u00EDe la palabra HELP para obtener ayuda.\n            ",
            vistaContentBeforeLink: "Se enviar\u00E1n alertas a la direcci\u00F3n de correo electr\u00F3nico y n\u00FAmero de tel\u00E9fono en su perfil."
        },
        termsConsentBanner: {
            title: 'Por favor, actualice su consentimiento',
            mainContentManageAlerts: "Para continuar recibiendo alertas de mensajes de texto sobre su cuenta, por favor, haga clic en \u201CACTUALIZAR CONSENTIMIENTO\" a continuaci\u00F3n y acepte los T\u00E9rminos y Condiciones."
        },
        a11y: {
            alertIsOn: 'Alerta Activada',
            alertIsOff: 'Alerta Desactivada'
        },
        phoneWarning: {
            linkLabel: 'agregue un número de teléfono a su perfil',
            contentBeforeLink: 'Por favor, ',
            contentAfterLink: ' para inscribirse en alertas de texto.'
        },
        smsTermsAndConditionLink: {
            termsAndConditionText: 'Al inscribirse en las alertas de mensaje de texto y/o de correo electrónico, usted acepta estos ',
            termsAndConditionLink: 'Términos.'
        },
        successModal: {
            title: '¡Excelente!',
            content: 'Hemos guardado sus cambios.',
            closeSuccessModal: 'CERRAR'
        },
        approvedTransactionInfo: {
            approvedTransactionLabel: 'Todas las transacciones',
            purchaseExeedsLabel: 'Todas las transacciones por encima de la cantidad especificada',
            content: 'Se pueden incluir notificaciones de cargos recurrentes e internacionales, también de pedidos hechos en línea, por correo o por teléfono (tarjeta no presente).',
            radioGroupLabel: 'Transacciones aprobadas alerta'
        },
        syfPayLaterInfo: {
            content: 'Siempre recibirá correos electrónicos sobre su cuenta de préstamo Pay Later y estos no pueden desactivarse. Si también desea recibir alertas por mensaje de texto, puede agregar esa opción aquí.'
        },
        helperText: {
            day: ' día',
            onStatus: 'ACTIVAR',
            offStatus: 'DESACTIVAR',
            atWord: 'en'
        },
        adaHelperText: {
            successBanner: 'Mostrando banner de éxito.',
            termsConditions: 'Mostrando términos y condiciones.'
        },
        maintenancePage: {
            title: 'Temporalmente sin Funcionamiento por Mantenimiento',
            knownTime: 'Esperamos regresar a las %t Hora del Este. Gracias por su paciencia.',
            unknownTime: 'Por favor regrese más tarde. ¡Lamentamos cualquier inconveniente y agradecemos su paciencia!'
        },
        dropdown: {
            days: 'días',
            day: 'día',
            endingIn: 'que termina en'
        },
        contactInformation: {
            title: 'Información de Contacto',
            content: 'Reciba alertas por correo electrónico y mensaje de texto con acciones importantes en su cuenta. Se enviarán alertas a la dirección de correo electrónico y número de teléfono en su perfil.',
            marketingSettingsContent: 'Las comunicaciones comerciales se enviarán a la información de contacto que está en su perfil.',
            phoneTitle: 'Numero de teléfono',
            emailTitle: 'Dirección de Correo Electrónico',
            addressTitle: 'Dirección',
            noPhoneNumberAvailable: 'No hay número en el archivo'
        },
        marketingSettingsBodyDisclaimerText: {
            content: 'Estas preferencias suyas no afectarán las comunicaciones como alertas sobre la actividad de su cuenta y correos electrónicos relacionados con el servicio.'
        },
        privacySettings: {
            policyText: 'Tiene opciones sobre qué y cómo compartimos con determinados terceros.',
            policyLink: 'Para revisar nuestra Política de Privacidad, haga clic aquí.',
            legalText: 'Para limitar la información que compartimos, por favor marque la casilla siguiente. La marca en la casilla significa que no compartiremos su información relacionada con esta cuenta de tarjeta con compañías fuera de la Familia Synchrony, más allá del expendedor de esta tarjeta y sus filiales y según lo permita la ley, como se describe en nuestra Política de Privacidad. Tampoco compartiremos información sobre su capacidad crediticia en relación con su cuenta dentro de la Familia Synchrony, como se define en la Política de Privacidad.',
            disclaimerText: 'Por favor tenga en cuenta que Synchrony Bank continuará compartiendo información con sus filiales, asociados conjuntos de comercialización y proveedores de servicios según lo permita la ley, tal como se describe en su Política de Privacidad.',
            acknowledgeLabel: 'Por favor no compartan información relacionada con mi cuenta fuera de la Familia Synchrony, el expendedor de esta tarjeta y sus filiales, y según lo permita la ley. Por favor no compartan información sobre mi capacidad crediticia en relación con esta cuenta con empresas dentro de la Familia Synchrony, como se define en la Política de Privacidad.'
        },
        alertsNotAvailableInfo: {
            title: 'Ups...',
            content: 'Lamentablemente administrar alertas no está disponible para esta cuenta.'
        }
    }
};
export default spanishTranslations;
